import React, { useEffect } from 'react';
import Icon from './Icon';
import './ui.css';

const Modal = ({
  open,
  onClose,
  title,
  children,
  footer,
  wide = false,
  form = false,
  className = '',
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  const modalClass = [
    'pn-modal',
    wide ? 'pn-modal--wide' : '',
    form ? 'pn-modal--form' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="pn-modal-overlay" role="dialog" aria-modal="true">
      <button type="button" className="pn-modal-backdrop" onClick={onClose} aria-label="Fechar" />
      <div className={modalClass}>
        {title ? (
          <div className="pn-modal__header">
            <h2 className="pn-modal__title">{title}</h2>
            <button type="button" className="pn-modal__close" onClick={onClose} aria-label="Fechar">
              <Icon name="close" size={20} />
            </button>
          </div>
        ) : null}
        <div className="pn-modal__body">{children}</div>
        {footer ? <div className="pn-modal__footer">{footer}</div> : null}
      </div>
    </div>
  );
};

export default Modal;
